import SafeIcon from '../common/SafeIcon';

export default function ContactDetails() {
  return (
    <div className="contact-details">
      <div><span className="contact-icon"><SafeIcon name="MapPin" /></span><p><strong>Address</strong><br />No. 20, A.K. Schnakenberg, Eththukala, Negombo.</p></div>
      <div><span className="contact-icon"><SafeIcon name="Phone" /></span><p><strong>Phone</strong><br /><a href="tel:+94741440731">+94 74 144 0731</a> · <a href="tel:+94741638458">+94 74 163 8458</a></p></div>
      <div><span className="contact-icon"><SafeIcon name="Mail" /></span><p><strong>Email</strong><br /><a href="mailto:kandsons.com@gmail.com">kandsons.com@gmail.com</a></p></div>
    </div>
  );
}